/* istanbul ignore file */
import React, { lazy } from 'react'

import SiteRoute from '../../components/SiteRoute'

const CambodiaNLIHP = lazy(() => import('./pages/CambodiaNLIHP'))

export default [<SiteRoute key="nlihp" exact path="/" component={CambodiaNLIHP} />]
